import { FC, ReactNode } from 'react';
import cx from 'classnames';

import { EmojiDisplay } from '@/components';

import styles from './AlertBox.module.sass';

type AlertBoxType = 'danger' | 'warning' | 'success' | 'info';
type IconPlacementType = 'start' | 'end';

interface AlertBoxProps {
  children: {
    title?: ReactNode;
    description?: ReactNode;
    icon?: ReactNode;
    actions?: ReactNode;
  };
  type?: AlertBoxType;
  className?: string;
  small?: boolean;
  iconPlacement?: IconPlacementType;
}

const AlertBox: FC<AlertBoxProps> = (props) => {
  const {
    children,
    type = 'info',
    className = '',
    small = false,
    iconPlacement = 'end',
  } = props;

  const {
    title = null,
    description = null,
    actions = null,
    icon = null,
  } = children;

  const alertClassName = cx(
    styles.alert,
    styles[type],
    className,
    small && styles.small,
  );

  const iconLeft = icon && iconPlacement === 'start';
  const iconRight = icon && iconPlacement === 'end';

  return (
    <div className={alertClassName}>
      {iconLeft && (
        <EmojiDisplay
          emoji={icon}
          className={`${styles.icon} ${styles['icon--start']}`}
        />
      )}
      <div className={styles.body}>
        {title && <div className={styles.title}>{title}</div>}
        {description && <div className={styles.description}>{description}</div>}
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {iconRight && (
        <EmojiDisplay
          emoji={icon}
          className={`${styles.icon} ${styles['icon--end']}`}
        />
      )}
    </div>
  );
};

export default AlertBox;
